import { cn } from "@/lib/utils";

export type SoldOutBadgeTone = "destructive" | "secondary";

interface SoldOutBadgeProps {
  /** Badge text. Defaults to the canonical "Sold Out". */
  label?: string;
  /** Visual tone. `destructive` = the red ss-1 pill; `secondary` = special order. */
  tone?: SoldOutBadgeTone;
  className?: string;
}

/**
 * THE single, canonical sold-out pill for the whole site (ss-1 styling).
 * Every category, product card, quick view and product page must render this
 * component so the sold-out look never diverges. Do not hand-roll another pill.
 */
export function SoldOutBadge({ label = "Sold Out", tone = "destructive", className }: SoldOutBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold shadow-sm",
        tone === "destructive"
          ? "bg-destructive text-destructive-foreground"
          : "bg-secondary text-secondary-foreground",
        className,
      )}
    >
      {label}
    </span>
  );
}
